<div class="allpaths">
  <!-- <div class="link-url" [routerLink]="'/allpaths'" routerLinkActive="selected"
    [routerLinkActiveOptions]="{ exact: true }">
    Home
  </div> -->
  <div class="link-url" [routerLink]="'/networth'" routerLinkActive="selected">
    Networth
  </div>
  <div class="link-url" [routerLink]="'/stocks'" routerLinkActive="selected">
    Stocks
  </div>
  <!-- <div class="link-url" [routerLink]="'/mf'" routerLinkActive="selected">
    Mutual Funds
  </div> -->
  <div class="link-url" type="button" (click)="logout()" [routerLink]="'/login'" routerLinkActive="selected">
    {{ userLoggedIn ? "Logout" : "Login" }}
  </div>
</div>